import React from 'react';
import { Link } from 'react-router-dom'; // Added for client-side routing

const GlobalNav = () => {
  return (
    <nav className="global-nav">
      <ul>
        <li><Link to="/" className="gold-link">Services</Link></li>
        <li><Link to="/web3pay" className="gold-link">Payments</Link></li>
        <li><Link to="/web3cash" className="gold-link">Cash</Link></li>
        <li><Link to="/web3fx" className="gold-link">Forex</Link></li>
        <li><Link to="/web3broker" className="gold-link">Broker</Link></li>
        <li><Link to="/web3markets" className="gold-link">Markets</Link></li>
        <li><Link to="/moneytalks" className="gold-link">MoneyTalks</Link></li>
        {/* External links (different apps) - keep as <a> tags */}
        <li><a href="https://banksystem.co/identity/" className="gold-link" target="_blank" rel="noopener noreferrer">Identity</a></li>
        <li><Link to="/dbank" className="gold-link">$DBANK</Link></li>
        <li><Link to="/features" className="gold-link">About</Link></li>
        <li><Link to="/safeguard" className="gold-link">SafeGuard</Link></li>
        {/* External link (wallet app) - keep as <a> tag */}
        <li><a href="https://banksystem.co/banksystem/" className="gold-link" target="_blank" rel="noopener noreferrer">BankSystem</a></li>
      </ul>
    </nav>
  );
};

export default GlobalNav;
